<template>
  <div class="d-flex align-items-center likeable" style="cursor: pointer;" @click="toggleLike">
    <span class="material-icons text-info mr-2" v-if="likedByUser">thumb_up</span>
    <span class="material-icons text-muted mr-1" v-if="!likedByUser">thumb_up_off_alt</span>
    <span>({{ likeable.likes ? likeable.likes.length : 0 }})</span>
  </div>
</template>

<script>

import graph_client from '../../utils/graphql/graph_client';
import { CreateLike, DestroyLike } from '../../utils/graphql/like-graph';
import { OnBoardingGoal } from "../../utils/models/OnBoardingGoal";

export default {
  props: {
    user: {
      type: Object,
      required: false,
    },
    likeable: {
      type: Object,
      required: true,
    },
    likeableType: {
      type: String,
      required: true,
    },
  },

  methods: {
    toggleLike() {
      if (!this.user) {
        // launch onboarding
        window.onBoardingVue.launchFor(OnBoardingGoal.Likes);
        return false;
      }

      if (this.likedByUser) {
        this.destroyLike();
      } else {
        this.createLike();
      }
    },

    createLike() {
      const likeParams = {
        like: {
          likeableId: this.likeable.id,
          likeableType: this.likeableType,
        },
      };

      // create the like via GraphQL createLike mutation
      graph_client.request(CreateLike, likeParams).then((response) => {
        const createdLike = response.createLike;
        // add the like to the likeable's likes array
        if (!this.likeable.likes) {
          this.$set(this.likeable, 'likes', []);
        }
        this.likeable.likes.push(createdLike);
      });
    },

    destroyLike() {
      const like = this.likeable.likes && this.likeable.likes.find((l) => l.user.firebaseUserId == this.user.firebase_user_id)
      if (!like) return;
      const likeParams = { like: { id: like.id } };

      // destroy the like via GraphQL destroyLike mutation
      graph_client.request(DestroyLike, likeParams).then((response) => {
        if (response.destroyLike.errors.length > 0) {
          alert(response.destroyLike.errors);
        }

        const destroyedLike = response.destroyLike;
        // remove the like from the likeable's likes array
        if (this.likeable.likes) {
          this.likeable.likes = this.likeable.likes.filter((l) => l.id !== destroyedLike.id);
        }
      });
    },
  },
  computed: {
    likedByUser() {
      if (!this.user) {
        return false;
      }

      return this.likeable.likes && this.likeable.likes.some((like) => like.user.firebaseUserId === this.user.firebase_user_id);
    },
  },
};
</script>
